var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.623,
    height: 54.623,
    viewBox: "0 0 54.623 54.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_369",
    x: 0,
    y: 0,
    width: 54.623,
    height: 54.623,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2c2828",
    floodOpacity: 0.259
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14418",
    "data-name": "Group 14418",
    transform: "translate(-1146.581 -529.286) rotate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11226",
    "data-name": "Group 11226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(1148 559.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_36_3",
    "data-name": "Component 36 \\u2013 3",
    transform: "translate(-2 -0.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, -8.83, -9.78)",
    filter: "url(#Ellipse_369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_369-2",
    "data-name": "Ellipse 369",
    transform: "translate(9 9.63) rotate(-1)",
    fill: "#fff",
    stroke: "rgba(136,152,170,0.5)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "chevron-right",
    transform: "translate(15.519 12.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-right-2",
    "data-name": "chevron-right",
    d: "M9,18l6-6L9,6",
    transform: "translate(-9 -6)",
    fill: "none",
    stroke: "#8898aa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.a5c9d8ca6e14703ff0043774a770e1b2.svg";
export { ForwardRef as ReactComponent };